import { RouteFactory } from "@app/routePaths";
import benpaulByline from "@assets/byline-photo/img-ben-paul.png";
import claressaByline from "@assets/byline-photo/img-claressa-monteiro.png";
import derrynByline from "@assets/byline-photo/img-derryn-wong.png";
import genevieveByline from "@assets/byline-photo/img-genevieve-cua.png";
import howieByline from "@assets/byline-photo/img-howie-lim.png";
import leslieByline from "@assets/byline-photo/img-leslie-yee.png";
import btCorrespondentsThumbnail from "@assets/podcasts_banner/img-bt-correspondents.jpg";
import btPodcastsThumbnail from "@assets/podcasts_banner/img-bt-podcasts.jpg";
import lensOnThumbnail from "@assets/podcasts_banner/img-lens-on.jpg";
import marketFocusThumbnail from "@assets/podcasts_banner/img-market-focus.jpg";
import moneyHacksThumbnail from "@assets/podcasts_banner/img-money-hacks.jpg";
import { FeedTag } from "@routes/Keyword/utils/types";
import { PodcastKeywordData } from "@routes/Podcasts/PodcastsPage/utils/types";

export const MONEY_HACKS_DETAILS: PodcastKeywordData = {
  id: "money_hacks",
  label: "MONEY HACKS",
  channel_link: "https://bt.sg/btmoneyhacks",
  tag: {
    name: "Money Hacks",
    urlPath: RouteFactory.podcastsMoneyHacks,
  } as FeedTag,
  description:
    "Weekly podcast with Howie Lim making personal finance and investing strategies clear, practical, and free of jargon.",
  thumbnailSrc: moneyHacksThumbnail,
  byline: [howieByline],
  subscribe: [
    { platform: "Spotify", link: "https://bt.sg/oeGN" },
    { platform: "Apple Podcasts", link: "https://bt.sg/oeXe" },
    { platform: "YouTube", link: "https://bt.sg/mhyt" },
  ],
};

export const BT_PODCASTS_DETAILS: PodcastKeywordData = {
  id: "bt_podcasts",
  label: "BT PODCASTS",
  tag: {
    name: "BT Podcasts",
    urlPath: RouteFactory.podcastsBTPodcasts,
  } as FeedTag,
  description:
    "BT Podcasts offer smart, authoritative storytelling and exclusive industry collaborations for listeners seeking clarity and fresh ideas.",
  thumbnailSrc: btPodcastsThumbnail,
  subscribe: [
    { platform: "Spotify", link: "https://bt.sg/pcSP" },
    { platform: "Apple Podcasts", link: "https://bt.sg/pcAP" },
    { platform: "YouTube", link: "https://bt.sg/giK9" },
  ],
};

export const LENS_ON_DETAILS: PodcastKeywordData = {
  id: "lens_on",
  label: "LENS ON SINGAPORE",
  channel_link: "https://bt.sg/btlenson",
  tag: { name: "Lens On", urlPath: RouteFactory.podcastsLensOn } as FeedTag,
  description:
    "Claressa Monteiro hosts candid conversations on geopolitical and societal issues shaping Singapore and the region's future.",
  thumbnailSrc: lensOnThumbnail,
  byline: [claressaByline],
  subscribe: [
    { platform: "Spotify", link: "https://bt.sg/lenssp" },
    { platform: "Apple Podcasts", link: "https://bt.sg/lensap" },
    { platform: "YouTube", link: "https://bt.sg/lensyt" },
  ],
};

export const BT_CORRESPONDENTS_DETAILS: PodcastKeywordData = {
  id: "bt_correspondents",
  label: "BT CORRESPONDENTS",
  channel_link: "https://bt.sg/ggYh",
  tag: {
    name: "BT Correspondents",
    urlPath: RouteFactory.podcastsBTCorrespondents,
  } as FeedTag,
  description:
    "BT Correspondents brings together leading BT columnists Ben Paul, Genevieve Cua, Derryn Wong and Leslie Yee with clear-eyed analysis of stocks, wealth, mobility and property.",
  thumbnailSrc: btCorrespondentsThumbnail,
  byline: [benpaulByline, genevieveByline, derrynByline, leslieByline],
  subscribe: [
    { platform: "Spotify", link: "https://bt.sg/btcosp" },
    { platform: "Apple Podcasts", link: "https://bt.sg/btcoap" },
    { platform: "YouTube", link: "https://bt.sg/btcoyt" },
  ],
};

export const MARKET_FOCUS_DETAILS: PodcastKeywordData = {
  id: "market_focus",
  label: "MARKET FOCUS WEEKLY",
  channel_link: "https://bt.sg/btmktfocus",
  tag: {
    name: "Market Focus",
    urlPath: RouteFactory.podcastsMarketFocus,
  } as FeedTag,
  description:
    "BT Podcasts correspondents deliver a weekly briefing on market moves and economic drivers across Singapore and the region.",
  thumbnailSrc: marketFocusThumbnail,
  subscribe: [
    { platform: "Spotify", link: "https://bt.sg/mfsp" },
    { platform: "Apple Podcasts", link: "https://bt.sg/mfap" },
    { platform: "YouTube", link: "https://bt.sg/mfyt" },
  ],
};

export const PODCASTS_KEYWORDS_DATA: PodcastKeywordData[] = [
  MONEY_HACKS_DETAILS,
  LENS_ON_DETAILS,
  BT_PODCASTS_DETAILS,
  BT_CORRESPONDENTS_DETAILS,
  MARKET_FOCUS_DETAILS,
];

export const DOWNLOAD_BT_APP_LINK = "https://onelink.to/annctm";
